import axios from 'axios';
import config from '../config';

const instance = axios.create({
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
});

/*
 * 401 and 403 normally mean the session is gone, and there is nothing a screen
 * can do about that except send the operator back to the login page.
 *
 * A few endpoints answer 403 for a reason that has nothing to do with the
 * session: the tariff refuses one more operator. That is an answer, not an
 * expired token, and treating it as one wiped the cookie and reloaded the panel
 * into /login the moment an admin tried to add a member over the limit - the
 * caller's own error handling was already in place and never got to run, so the
 * admin saw themselves thrown out of the system instead of being told why.
 *
 * Those requests pass businessForbidden and keep their 403 to themselves.
 */
export default function (requestData) {
  return instance(requestData).catch(err=>{
      const sessionIsGone = err.response
          && (err.response.status === 401
              || (err.response.status === 403 && !requestData.businessForbidden));

      if (sessionIsGone && !requestData.url.endsWith('/login')) {
          document.cookie = "jwt-access-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          window.location.href = config.APP_HOST + '/login';
      }
      return Promise.reject(err);
  });
}



// WEBPACK FOOTER //
// ./src/utils/RequestManager.js